import axios from 'axios';
import Config from '../constants/Config';

const client = axios.create({
    baseURL: Config.BASE_URL,
    timeout: 30000,
    headers: {Accept: 'application/json'}
});

client.interceptors.response.use(
    function (response)
    {
        return response;
    },
    function (error)
    {
        return Promise.reject(error);
    }
);


export async function request(args)
{
    const response = await client.request(args);

    return response.data;
}
